import type { TierKey } from './hooks/useSubscription';

export const PLANS = [
  {
    id: 'solo' as const,
    tierKey: 'standard' as TierKey,
    name: 'Solo',
    monthlyPrice: 19,
    yearlyPrice: 190,
    monthlyEquivalent: 16,
    description: 'Pour les praticiens indépendants',
    features: [
      '1 praticien',
      'Clients & sessions illimités',
      'Contrats & consentements',
      'Facturation électronique Factur-X',
      'Dashboard & pipeline',
      'Templates personnalisables',
      'Application mobile',
      'Support email',
    ],
    cta: "Commencer l'essai gratuit",
    highlighted: false,
    badge: null as string | null,
  },
  {
    id: 'studio' as const,
    tierKey: 'pro' as TierKey,
    name: 'Studio',
    monthlyPrice: 49,
    yearlyPrice: 490,
    monthlyEquivalent: 41,
    description: "Pour les studios jusqu'à 5 artistes",
    features: [
      "Jusqu'à 5 praticiens",
      'Tout Solo inclus',
      'Gestion studio (résidents & guests)',
      'Système de référals entre artistes',
      'Inventaire commun ou individuel',
      'Finances artistes (loyer, commissions)',
      'Pipeline kanban studio',
      'Support prioritaire',
    ],
    cta: "Commencer l'essai gratuit",
    highlighted: true,
    badge: 'Populaire' as string | null,
  },
  {
    id: 'studio_pro' as const,
    tierKey: 'studio_pro' as TierKey,
    name: 'Studio Pro',
    monthlyPrice: 89,
    yearlyPrice: 890,
    monthlyEquivalent: 74,
    description: "Pour les grands studios jusqu'à 15 artistes",
    features: [
      "Jusqu'à 15 praticiens",
      'Tout Studio inclus',
      'Segmentation CRM avancée',
      'Intégration Brevo (email & SMS)',
      'API partenaires fournisseurs',
      'Commandes automatiques stock',
      'Rapports avancés & exports',
      'Support dédié & onboarding',
    ],
    cta: "Commencer l'essai gratuit",
    highlighted: false,
    badge: null as string | null,
  },
];

export const PRICE_IDS: Record<typeof PLANS[number]['id'], { monthly: string; yearly: string }> = {
  solo:       { monthly: 'price_1TZGjeCz8icEUXUDwOE3DaiK', yearly: 'price_1TZGkwCz8icEUXUDB6yw1oDF' },
  studio:     { monthly: 'price_1TZGptCz8icEUXUDa7N9OdEF', yearly: 'price_1TZGqeCz8icEUXUDpmlxPRqy' },
  studio_pro: { monthly: 'price_1TZGtaCz8icEUXUD4eSxe6Mv', yearly: 'price_1TZGtaCz8icEUXUDuUBtlYAt' },
};

export type Plan = typeof PLANS[number];
